var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02857 5.84615C6.02857 2.62277 8.70754 0 12 0C15.2925 0 17.9714 2.62277 17.9714 5.84615C17.9714 9.06954 15.2925 11.6923 12 11.6923C8.70754 11.6923 6.02857 9.06954 6.02857 5.84615ZM15.7714 13.5385H8.22857C4.24343 13.5385 1 16.7138 1 20.6154C1 22.4825 2.55006 24 4.45714 24H19.5429C21.4499 24 23 22.4825 23 20.6154C23 16.7138 19.7566 13.5385 15.7714 13.5385Z",
    fill: "#ff5a3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.68a113151cd1e98a61cf8904e92b22bf.svg";
export { ForwardRef as ReactComponent };